import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-employee-tree',
  templateUrl: './employee-tree.component.html',
  styleUrls: ['./employee-tree.component.css']
})
export class EmployeeTreeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
